import { getInspectionPeriodRows } from '../utils/inspectionPeriodMethods';

export default function InspectionPeriodMethodsTable({ frequency, methodType, value, onChange }) {
  if (methodType !== 'VARIES_BY_PERIOD') return null;

  const rows = getInspectionPeriodRows(frequency);
  const methods = value || {};

  const updateRow = (key, text) => {
    onChange({ ...methods, [key]: text });
  };

  return (
    <div className="md:col-span-2 border border-gray-200 rounded-lg overflow-hidden">
      <div className="bg-gray-50 px-4 py-2 border-b">
        <p className="text-sm font-medium text-gray-900">Inspection method by period</p>
        <p className="text-xs text-gray-500 mt-0.5">
          Enter the procedure text for each period. Inspectors will use these sentences during checks (auto-suggest later).
        </p>
      </div>
      <div className="max-h-64 overflow-y-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-white sticky top-0">
            <tr>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500 w-36">Period</th>
              <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">Inspection procedure</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {rows.map((row) => (
              <tr key={row.key}>
                <td className="px-4 py-2 text-sm text-gray-800 align-top whitespace-nowrap">{row.label}</td>
                <td className="px-4 py-2">
                  <textarea
                    value={methods[row.key] || ''}
                    onChange={(e) => updateRow(row.key, e.target.value)}
                    rows={2}
                    className="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-1 focus:ring-primary-500"
                    placeholder="Describe how to inspect in this period…"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
